import React from "react";
import { useTranslation } from "react-i18next";
import { CheckOutlined } from "@ant-design/icons";

const FEATURE_KEYS = ["ai", "data", "predict", "outsource"];

export default function AuthMarketingPanel() {
    const { t } = useTranslation();

    return (
        <aside className="auth-marketing">
            <h1 className="auth-marketing-title">
                {t("loginPage.marketing.title")}
            </h1>
            <p className="auth-marketing-subtitle">
                {t("loginPage.marketing.subtitle")}
            </p>
            <ul className="auth-marketing-features">
                {FEATURE_KEYS.map((key) => (
                    <li key={key} className="auth-marketing-feature">
                        <span className="auth-marketing-icon" aria-hidden="true">
                            <CheckOutlined />
                        </span>
                        <div className="auth-marketing-feature-body">
                            <h3>{t(`loginPage.marketing.features.${key}.title`)}</h3>
                            <p>{t(`loginPage.marketing.features.${key}.description`)}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </aside>
    );
}
